"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TASK_REVIEW_BASE_COLUMNS = exports.EXPLANATION_COLUMN_ID = exports.REVIEWED_COLUMN_ID = void 0;
const table_columns_1 = require("../../../../common/table-columns");
const attributes_1 = require("../../../../constants/attributes");
exports.REVIEWED_COLUMN_ID = 'reviewedStatus';
exports.EXPLANATION_COLUMN_ID = 'explanation';
exports.TASK_REVIEW_BASE_COLUMNS = [
    attributes_1.CustomProductAttributes.ExternalId,
    attributes_1.CustomProductAttributes.Name,
    exports.REVIEWED_COLUMN_ID,
    ...table_columns_1.BASE_ENRICHED_COLUMNS,
    exports.EXPLANATION_COLUMN_ID,
    attributes_1.CustomProductAttributes.LastReviewedBy,
];
